var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container-fluid" },
    [
      _c("loading", {
        attrs: { active: _vm.isLoading, loader: "dots" },
        on: {
          "update:active": function ($event) {
            _vm.isLoading = $event
          },
        },
      }),
      _c("div", { staticClass: "chart-page" }, [
        _c("div", { staticClass: "card mb-2" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "chart-title mb-4" }, [
              _vm._v("階段占比報表"),
            ]),
            _c(
              "div",
              { staticClass: "form-row" },
              _vm._l(_vm.phaseData, function (chart, index) {
                return _c(
                  "div",
                  { key: chart.index, staticClass: "col-sm-12 col-md-4" },
                  [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("apexchart", {
                          staticClass: "chart",
                          attrs: {
                            width: "400",
                            type: "donut",
                            options: _vm.phaseChart,
                            series: chart,
                          },
                        }),
                        _vm.phaseData
                          ? _c(
                              "p",
                              { staticStyle: { "text-align": "center" } },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm._f("month")(_vm.rows[index].Month)
                                    ) +
                                    "月份 "
                                ),
                              ]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                )
              }),
              0
            ),
          ]),
        ]),
        _c("div", { staticClass: "card mb-2" }, [
          _c("div", { staticClass: "card-body" }, [
            _c("div", { staticClass: "form-row" }, [
              _c(
                "div",
                { staticClass: "col-sm-12 col-md-6" },
                [
                  _c("div", { staticClass: "chart-title mb-2" }, [
                    _vm._v("黑名單報表"),
                  ]),
                  _c("apexchart", {
                    attrs: {
                      width: "100%",
                      height: "450",
                      type: "bar",
                      options: _vm.blacklistChart,
                      series: _vm.blacklistSeries,
                    },
                  }),
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-sm-12 col-md-6" },
                [
                  _c("div", { staticClass: "chart-title mb-2" }, [
                    _vm._v("登入紀錄報表"),
                  ]),
                  _c("apexchart", {
                    attrs: {
                      type: "bar",
                      width: "100%",
                      height: "450",
                      options: _vm.loginRecordChart,
                      series: _vm.loginRecordData,
                    },
                  }),
                ],
                1
              ),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }